module.exports = __webpack_public_path__ + "static/img/warehouse.6489403.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/warehouse.jpg
// module id = W8cB
// module chunks = 1